var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDollar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        fill: #ffc000;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Currency"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Dollar",
    className: "st0",
    d: "M293.6,334.7c0-11.9-2.9-21.3-8.8-28.1s-16.2-13.2-31-19.2-28.5-12.1-41-18.3-23.3-13.4-32.4-21.5-16-17.6-20.8-28.3-7.2-23.7-7.2-38.9c0-25.5,8.6-46.5,25.8-63s40.1-26.1,68.8-28.9v-47.9h36v48.7c27.6,4.1,49.3,15.4,65.1,34.1,15.8,18.7,23.6,42.3,23.6,71h-76.5c0-15.7-3-27.8-9.1-36.2-6-8.4-14.6-12.7-25.8-12.7s-17.7,3.1-23.2,9.4-8.3,14.9-8.3,25.9,3.2,20,9.5,26.6,16.5,12.8,30.6,18.8c14,6,27.3,12.1,39.7,18.6,12.4,6.4,23.2,13.7,32.3,21.8s16.1,17.7,21.3,28.5c5.1,10.9,7.7,23.9,7.7,39.2,0,25.8-8.2,46.9-24.6,63.1-16.4,16.3-38.7,25.8-66.9,28.5v45.5h-36v-45.7c-32.9-3.5-58.1-14.8-75.7-33.8-17.6-19.1-26.4-44.2-26.4-75.5h76.3c0,17.2,3.8,30.3,11.4,39.3s18.4,13.5,32.5,13.5,18.3-3.1,24.2-9.2c5.9-6.2,8.9-14.6,8.9-25.3h0Z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDollar);
export default __webpack_public_path__ + "static/media/dollar.1cbac7a15e87ee9293a48a85fd4c2898.svg";
export { ForwardRef as ReactComponent };